import { Badge, Box, IconButton, Typography, List, ListItem, ListItemText, ListItemSecondaryAction, Divider, Button, DialogTitle, Stack, ButtonGroup } from '@mui/material';
import { Cancel, CreditCard, Delete, Edit, ErrorOutline, LocalShipping } from '@mui/icons-material';
import React, { useEffect, useState, Fragment } from 'react';
import __t from '../lib/traduzioni';
import { useLocalStorage } from 'react-use';
import { useTheme } from '@mui/material';

import useBSSLogger from '../hooks/useBSSLogger';
import { labelLocalita, nextUrlByStep } from './preventivo/frammenti/FrammentoRiepilogo';
import useSWRImmutable from 'swr/immutable';
import DefaultLoadingComponent from './form/DefaultLoadingComponent';
import { retrieveTipispedizione } from '../api/tipospedizione';
import currencies from '../currencies';

const {logger} = useBSSLogger();

import { format, parse } from 'date-fns';
import { convertiFormRequestCalcola, NoPreviousData } from './preventivo/Preventivo';

import { orderFromCart, previousCart } from '../api/testataordine'; 
import BSSDrawer from './form/BSSDrawer';
import { BSSConfirmDialog } from './form/BSSDialog';
import { Alert } from '@mui/material';
import MenuUtente from './account/MenuUtente';
import DefaultErrorComponent from './form/DefaultErrorComponent';

const CODICICONVALIDACARRELLO = {
    DATADIRITIRONONVALIDA: {codice: "DATADIRITIRONONVALIDA", messaggio: __t("dataritirononvalida")}, // data di ritiro non è valida
    IDPREZZONONVALIDO: {codice: "IDPREZZONONVALIDO", messaggio: __t("prezzononvalido")}, // id del prezzo (di listino) non è valido
    TOTALESPEDIZIONENONVALIDO: {codice: "TOTALESPEDIZIONENONVALIDO", messaggio: __t("prezzononvalido")}, // totale della spedizione non è valido: difformità nel prezzo del listino o negli addizionali
    PARTENZANONVALIDA: {codice: "PARTENZANONVALIDA", messaggio: __t("partenzanonvalida")}, // from non valido
    DESTINAZIONENONVALIDA: {codice: "DESTINAZIONENONVALIDA", messaggio: __t("destinazionenonvalida")}, // to non valido
    LOCALITANONVALIDE: {codice: "LOCALITANONVALIDE", messaggio: __t("localitanonvalide")} // to non valido
}

/**
 * Ottiene i dati del carrello tra database (tramite webservice) e localstorage, quindi li passa al componente figlio richiamandolo come funzione.
 * Il componente figlio è al momento solo MenuCarrello
 * 
 * @param {*} props 
 * @returns 
 */
const CarrelloDaDB = (props) => {


    const [carrelloStorage = {preventivi: [], pagamenti: {}, datiFatturazione: {}}, aggiornaCarrelloStorage, rimuoviCarrelloStorage] = useLocalStorage("spedizioniweb2_preventivo_carrello");

    useEffect(()=>{
        document.addEventListener("spedizioniweb2_preventivo_carrello", () => {
            logger.debug("sessione aggiornata per il carrello", localStorage.getItem("spedizioniweb2_preventivo_carrello"))
            location.reload()
        })
    }, [])


    const datiIniziali = async () => {         
        
        const url = new URL(location.href);
        const chiaviSearch = Array.from(url.searchParams.entries());

        chiaviSearch.forEach(([chiave, valore]) => {
            if(chiave.toLowerCase() === 'referral'){
                localStorage.setItem("spedizioniweb2_referral", valore.toUpperCase())
            }

        })

        const prevcart = await previousCart();

        const {listapreventivivalidazione: preventivi = [], datiintestazionevalidazione: datiFatturazione = {}, jsonpagamentivalidazione = null} = prevcart;
        
        /**
         * i campi sul db sono in inglese, quelli in storage in italiano
         */
        const mappaColli = {
            lunghezza: 'length',
            larghezza: 'width',
            altezza: 'height',
            peso: 'weight',
            qta: 'qt',
            naturamerce: 'contentcode',
        }
        
        const colliMapper = (colloOri) => {
            const collo = Object.keys(mappaColli).reduce(
                (obj, chiave) => ({
                    ...obj,
                    [chiave]: colloOri[mappaColli[chiave]],
                }),
                {},
            )
        
            return collo
        }        
        
        //dato un preventivo da carrello sul db lo converte in preventivo in carrello nello storage del browser
        const preventivoMapper = (preventivoDB) => {
            //let {mittente, destinatario} = preventivoDB.contacts
            let {order, packages, from, to, shipmenttype, contacts = [], pickupdate: dataritiro} = preventivoDB

            const mittente = contacts.find(({mittenteodestinatario}) => mittenteodestinatario === "M");
            const destinatario = contacts.find(({mittenteodestinatario}) => mittenteodestinatario === "D");
        
            //mittente.indirizzo = mittente?.listaindirizzi?.[0] ?? null
            //destinatario.indirizzo = destinatario?.listaindirizzi?.[0] ?? null
            let valmerce = order?.valmerce ?? 0
            let colli = (packages ?? []).map(colliMapper)
            let {country: nazione_partenza, city: comune_partenza} = from
            let {country: nazione_arrivo, city: comune_arrivo} = to
            let tipoSelezionato = shipmenttype?.id ?? null
            let step = 3
            let preventivoSelezionato = {...(order ?? {})};
            // {
            //     ...order?.price ?? {},
            //     pricelist: order?.pricelist,
            //     totalprice: order?.totalprice ?? 0
            // }

            const idprodotto = order.price.associazione.prodotto.id;

            const addizionalisceltiById = order.addizionaliscelti.reduce((obj, addizionale) => ({...obj, [Number(addizionale.id)]: addizionale.valore}), {})

            const addizionaleValueGetter = (addizionaleReale, valoreStringa) => {
                let valore = valoreStringa;

                const tipo = addizionaleReale.tipo.value;

                if(["D", "I"].includes(tipo)){
                    valore = Number(valoreStringa);
                }

                if(["B"].includes(tipo)){
                    valore = valoreStringa === "true" ? true : false
                }


                return valore;
            }

            const addizionali = order.listaaddizionali.reduce((obj, addizionale) => ({
                ...obj,
                [`prodotto_${idprodotto}`]: {
                    ...obj[`prodotto_${idprodotto}`],
                    [`addizionale_${addizionale.id}`]: addizionaleValueGetter(addizionale, addizionalisceltiById[Number(addizionale.id)] ?? null)
                }                
            }), {[`prodotto_${idprodotto}`]: {}})
            
            logger.debug("recupero gli addizionali scelti dal json sul db", addizionali)


            const {validaPreventivo, validaCodice} = preventivoSelezionato;

            const validita = {
                validaPreventivo, 
                validaCodice, 
                errori: [null, undefined].includes(validaCodice) ? null : CODICICONVALIDACARRELLO[validaCodice?.value ?? null] ?? null
            };
        
            return {
                mittente,
                destinatario,
                valmerce,
                colli,
                dataritiro,
                nazione_partenza,
                nazione_arrivo,
                tipoSelezionato,
                step,
                addizionali,
                comune_partenza,
                comune_arrivo,
                preventivoSelezionato,
                validita
            }
        }
        
        const carrelloDaDB = {
            datiFatturazione: datiFatturazione ?? null,
            preventivi: (preventivi ?? []).map(preventivoMapper),  
            db: {...(prevcart ?? {})}         
        }

        logger.debug("carrello da database", carrelloDaDB)

        aggiornaCarrelloStorage(carrelloDaDB)

        return {carrelloDaDB}

    }

    const {data, error} = useSWRImmutable("/api/datiinizialimenucarrello", datiIniziali, {
        onErrorRetry: (error, key, config, revalidate) => {
            return 
            // if(error === "NO_PREVIOUS_DATA"){
            //     logger.debug("non ho dati pregressi!")
            //     return
            // }
        }
    })

    if(!error && !data){
        return (<DefaultLoadingComponent SkeletonProps={{variant: "circular", height: 40, width: 40}} />) 
    } 

    if(error){
        return (
            <DefaultErrorComponent {...{error}} />
        )
    }

    logger.debug("carrello da database prima di rendering", data)

    return (
        <>
            {props.children(data.carrelloDaDB)}
        </>
    )
}

const carrelloConErrori = preventivi => (preventivi.find(preventivo => (preventivo?.validita?.validaPreventivo ?? true) === false) !== undefined)


/**
 * Menu del carrello e dell'account utente. Può essere posizionato tramite props. Lo script per mostrare questo componente è documentato in 
 * personalizzazionetemi/readme.md
 * 
 * @param {*} param0 
 * @returns 
 */
const MenuCarrello = ({position = {right: "1vw", top: "2vh"}, mostraMenuUtente = true}) => {    

    const [openCart, setOpenCart] = useState(false)    
    
    return (
        <>
            <Box sx={{position: "fixed", zIndex: 9999,  ...position}}>
                <CarrelloDaDB >
                    {({preventivi}) => {

                        const errori = carrelloConErrori(preventivi);

                        return (
                            <>
                                {/*draggable rompe il funzionamento del menu di MenuUtente*/}
                                {/* <Draggable disabled={true}> */}
                                <ButtonGroup variant="contained">
                                    {(mostraMenuUtente === true) && (
                                        <MenuUtente />
                                    )}
                                    
                                    <Button onClick={e => setOpenCart(true)}>
                                        <Badge badgeContent={preventivi?.length ?? 0} max={9} color="primary">
                                            
                                            {(errori === true) && (
                                                <ErrorOutline color={"error"} />
                                            )}
                                            <LocalShipping />
                                        </Badge>            
                                    </Button>
                                </ButtonGroup>
                                {/* </Draggable> */}
                                <BSSDrawer                                                  
                                    anchor="left"                                 
                                    open={openCart} onClose={e => setOpenCart(false)}
                                >

                                    
                                    <Box p={3}>

                                        <DialogTitle disableTypography className="drawerTitle" sx={{display: "flex", justifyContent: "flex-end", padding: "0"}}>
                                            <IconButton size={"large"} onClick={e => setOpenCart(false)}>
                                                <Cancel color="secondary" />
                                            </IconButton>
                                        </DialogTitle>

                                        <Carrello mostraLink={true} />                
                                    </Box>                        

                                </BSSDrawer>     
                            </>
                        )

                    }}                                                                                                  
                </CarrelloDaDB>
            </Box>
        </>
    )
}

const Carrello = ({mostraLink = false}) => {


    const [carrelloStorage = {preventivi: [], pagamenti: {}, datiFatturazione: {}}, aggiornaCarrelloStorage, rimuoviCarrelloStorage] = useLocalStorage("spedizioniweb2_preventivo_carrello");
    const [preventivoStorage, aggiornaPreventivoStorage, rimuoviPreventivoStorage] = useLocalStorage("spedizioniweb2_preventivo_form");

    const {preventivi} = carrelloStorage    

    const [dialogElimina, setDialogElimina] = useState({mostra: false, preventivo: null, indicePreventivo: null})
    const [dialogModifica, setDialogModifica] = useState({mostra: false, preventivo: null, indicePreventivo: null})

    const [dialogAction, setDialogAction] = useState({mostra: false, preventivo: null, indicePreventivo: null, action: null})

    const theme = useTheme()

    const datiIniziali = async () => {

        const tipiSpedizione = await retrieveTipispedizione();

        return {tipiSpedizione} 

    }

    const {data = {}, error} = useSWRImmutable("/api/datiinizialimenucarrello", datiIniziali)

    if(!error && !data){
        return (<DefaultLoadingComponent SkeletonProps={{variant: "circular"}} />)
    } 

    if(error){
        return <DefaultErrorComponent {...{error}} />
    }

    const {tipiSpedizione = []} = data;

    const elimina = async (preventivo, indicePreventivo) => {


        const carrelliRimanenti = carrelloStorage.preventivi.filter((p, i) => indicePreventivo !== i)

        logger.debug("elimino carrello ", preventivo, "risultato", carrelliRimanenti, "a partire da ", carrelloStorage.preventivi)

        aggiornaCarrelloStorage({
            ...carrelloStorage,
            preventivi: carrelliRimanenti
        })

        document.dispatchEvent(new CustomEvent("spedizioniweb2_preventivo_carrello"))

        const dati = {
            carrello: {
                preventivi: !(Array.isArray(carrelliRimanenti) && carrelliRimanenti.length > 0) ? null :  [
                    ...carrelliRimanenti.map(preventivo => convertiFormRequestCalcola(preventivo)),
                ],
            },
        }
        
        await orderFromCart(dati);

        setDialogAction({mostra: false, preventivo: null, indicePreventivo: null})
    }

    const modifica = (preventivo, indicePreventivo) => {     

        //se nel preventivo è presente un comune con id null, al posto dell'oggetto comune devo creare due string cap_comune_(partenza|arrivo) e comune_comune_(partenza|arrivo)
        ["partenza", "arrivo"].forEach(contesto => {
            const objcomune = preventivo[`comune_${contesto}`] ?? {};
            const {id, cap, comune} = objcomune;

            if(id === null){
                preventivo[`cap_comune_${contesto}`] = cap;
                preventivo[`comune_comune_${contesto}`] = comune;
                delete preventivo[`comune_${contesto}`];
            }

        })
        logger.debug("vado in modifica di un preventivo dal carrello", preventivo, preventivi)

        let nextStep = 3;
        
        const validitaPreventivo = preventivo.validita;
        const valido = validitaPreventivo.validaPreventivo;

        let flashMessages = null;

        if(valido === false){
            const enumValido = validitaPreventivo.validaCodice;
            const codice = enumValido.value;
            

            logger.debug("preventivo con errori", codice, CODICICONVALIDACARRELLO[codice]);
            let livelloErrore = 0;

            if(codice === CODICICONVALIDACARRELLO.DATADIRITIRONONVALIDA.codice){
                //devo svuotare la data di ritiro, quindi rimandare allo step 3
                nextStep = 3;
                livelloErrore = 1;
            }

            if([CODICICONVALIDACARRELLO.IDPREZZONONVALIDO.codice, CODICICONVALIDACARRELLO.TOTALESPEDIZIONENONVALIDO.codice].includes(codice)){
                //come livelloErrore 1, ma in più deve svuotare il preventivo e gli addizionali scelti, quindi rimandare allo step 2 
                nextStep = 2;
                livelloErrore = 2;
            }

            if([CODICICONVALIDACARRELLO.PARTENZANONVALIDA.codice, CODICICONVALIDACARRELLO.DESTINAZIONENONVALIDA.codice].includes(codice)){
                //come livelloErrore 1 e 2, ma in più deve svuotare la località non valida e i contatti, quindi rimandare allo step 1
                nextStep = 1;
                livelloErrore = 3;
            }

            const svuotaLocalita = contesto => {
                let mittdest = "mittente";
                if(contesto === "arrivo"){
                    mittdest = "destinatario";
                }
                delete preventivo[`nazione_${contesto}`];
                delete preventivo[`comune_${contesto}`];
                delete preventivo[`cap_comune_${contesto}`];
                delete preventivo[`comune_comune_${contesto}`];
                delete preventivo[mittdest];
            }

            switch(livelloErrore){
                case 3: 
                    if(codice === CODICICONVALIDACARRELLO.LOCALITANONVALIDE.codice){
                        svuotaLocalita("partenza");
                        svuotaLocalita("arrivo");
                    }

                    if(codice === CODICICONVALIDACARRELLO.PARTENZANONVALIDA.codice){
                        svuotaLocalita("partenza");
                    }
                    if(codice === CODICICONVALIDACARRELLO.DESTINAZIONENONVALIDA.codice){
                        svuotaLocalita("arrivo");
                    }
                case 2: 
                    delete preventivo.preventivoSelezionato;
                    delete preventivo.addizionali;
                case 1: 
                    delete preventivo.dataritiro;
                    break;
                default: logger.info("il codice di errore non è gestito", codice, "codici validi:", CODICICONVALIDACARRELLO);
                    break;

            }

            flashMessages = [{tipo: "error", messaggio: CODICICONVALIDACARRELLO?.[codice]?.messaggio ?? enumValido.label}]
        }


        logger.debug("preventivo con errori sanificato", preventivo, "faccio il redirect allo step", nextStep, flashMessages);

        aggiornaPreventivoStorage(preventivo);
        elimina(preventivo, indicePreventivo);
        location.href = nextUrlByStep(nextStep, flashMessages);
    }

    const vaipagamenti = () => {
        location.href = nextUrlByStep(4)
    }

    const errori = carrelloConErrori(preventivi);


    return (
        <>
            <Box pb={2}>
                <Typography variant="h5" sx={{textAlign: "center"}}>
                    {__t("listaspedizioni")} ({carrelloStorage?.preventivi?.length ?? 0})
                </Typography>
            </Box>

            {(preventivi.length <= 0) && (
                <NoPreviousData noMessage />
            )}

            {(errori === true) && (
                <Alert severity={"error"}>
                    {__t("preventiviconerrori")}
                </Alert>
            )}


            {(preventivi.length > 0) && (
                <List style={{paddingLeft: 0}} >  
                    {mostraLink && (<ListItem disableGutters key="pagatop">
                        <ListItemText > 
                            <Button onClick={e => vaipagamenti()} fullWidth variant="contained" color="primary">
                                <CreditCard />{" "}{__t("pagamento")}
                            </Button>                               
                        </ListItemText>
                    </ListItem>)}                    
                </List>
            )}

            <Divider />


            <List style={{paddingLeft: 0}} >                        

                {preventivi.map((preventivo, indicePreventivo) => {

                    const {colli = [], tipoSelezionato, validita} = preventivo;
                    const qtatot = colli.reduce((somma, collo) => Number(somma) + Number(collo.qta), 0)
                    const tipoObj = tipiSpedizione.find(t => t.id === tipoSelezionato)
                    const valuta = currencies[preventivo?.preventivi?.currency ?? "EUR"];
                    logger.debug("preventivo da carrello", preventivo)
                    const prezzo = `${valuta.symbol} ${preventivo.preventivoSelezionato.totalprice.toFixed(valuta.decimal_digits)}` 
                    const validitaPreventivo = preventivo.validita ?? {};

                    return (
                        <Fragment key={`frag_${indicePreventivo}`}>
                            <Box w={1}>
                                {((validitaPreventivo.validaPreventivo ?? true) === false) && (
                                    <Alert severity={"error"}>
                                        {validitaPreventivo.errori?.messaggio ?? validitaPreventivo.validaCodice?.label ?? __t("nonvalido")}
                                    </Alert>
                                )}
                            </Box>
                            <ListItem disableGutters key={indicePreventivo}>
                                    

                                <ListItemCarrello {...{prezzo, qtatot, tipoObj, preventivo, indicePreventivo}} />  
                                <ListItemSecondaryAction>
                                    <IconButton edge="end" size="small" color="primary"
                                        onClick={e => setDialogAction({mostra: true, preventivo, indicePreventivo, operazione: "modifica"})}
                                        >
                                        <Edit />
                                    </IconButton>
                                    <br />
                                    <IconButton edge="end" size="small" style={{color: theme.palette.error.main}} 
                                        onClick={e => setDialogAction({mostra: true, preventivo, indicePreventivo, operazione: "elimina"})}>
                                        <Delete />
                                    </IconButton>
                                </ListItemSecondaryAction>
                                
                            </ListItem>
                            <Divider />
                        </Fragment>
                    )
                })}

            </List>

            
            {(preventivi.length > 0) && (
                <List style={{paddingLeft: 0}} >  
                    {mostraLink && (<ListItem disableGutters key="pagabottom">
                        <ListItemText > 
                            <Button onClick={e => vaipagamenti()} fullWidth variant="contained" color="primary">
                                <CreditCard />{" "}{__t("pagamento")}
                            </Button>                               
                        </ListItemText>
                    </ListItem>)}                    
                </List>
            )}

            <DialogActionDaCarrello {...{dialogAction, setDialogAction, tipiSpedizione, theme, aggiornaPreventivoStorage, modifica, elimina}} />

            {/* <DialogEliminaDaCarrello {...{dialogElimina, setDialogElimina, tipiSpedizione, theme, elimina}}  />
            <DialogModificaDaCarrello {...{dialogModifica, setDialogModifica, tipiSpedizione, theme, aggiornaPreventivoStorage, modifica}}  /> */}
        </>
    )
}

const DialogActionDaCarrello = ({tipiSpedizione = [], dialogAction = {mostra: false, preventivo: {}, indicePreventivo: null, operazione: null}, setDialogAction, theme, aggiornaPreventivoStorage, modifica, elimina}) => {

    const {preventivo = {}, indicePreventivo = null, operazione = null} = dialogAction;

    if(preventivo === null || operazione === null) return ""

    const {colli = [], tipoSelezionato} = preventivo;
    const qtatot = colli.reduce((somma, collo) => Number(somma) + Number(collo.qta), 0)
    const tipoObj = tipiSpedizione.find(t => t.id === tipoSelezionato)
    const valuta = currencies[preventivo?.preventivi?.currency ?? "EUR"];
    const prezzo = `${valuta.symbol} ${(preventivo?.preventivoSelezionato?.totalprice ?? 0).toFixed(valuta.decimal_digits)}`

    const title = operazione === 'modifica' ? __t("modificapreventivo") : __t("eliminapreventivo");
    const question = operazione === 'modifica' ? __t("questionconfermmodificapreventivo") : __t("questionconfermaeliminapreventivo");
    const bg = operazione === 'modifica' ? "warning" : "error";
    const fnop = operazione === 'modifica' ? modifica : elimina;

    return (
        <>
        <BSSConfirmDialog  
            title={title}         
            open={dialogAction.mostra}
            undoAction={e => setDialogAction({mostra: false, preventivo: {}, indicePreventivo, operazione})}
            confirmAction={e => fnop(dialogAction.preventivo, dialogAction.indicePreventivo)}
            confirmBtnProps={{style: {color: theme.palette.grey[100],  backgroundColor: theme.palette[bg].main}}}
        >
            {/* <pre>{JSON.stringify(preventivo, null, 2)}</pre> */}
            <ListItem disableGutters>
                <ListItemCarrello {...{prezzo, qtatot, tipoObj, preventivo, indicePreventivo}} />  
            </ListItem>

            <Alert severity={"warning"}>                    
                {question}
            </Alert>
        </BSSConfirmDialog>    
        
        </>
    )
}

const ListItemCarrello = ({prezzo, qtatot, tipoObj, preventivo, indicePreventivo}) => {

    const theme = useTheme()

    const validitaPreventivo = preventivo.validita;

    return (
        preventivo.dataritiro ? (
            <>
                <ListItemText 
                    primary={(
                        <>
                            {/* {((validitaPreventivo.validaPreventivo ?? true) === false) && (
                                <Alert severity={"error"}>
                                    {validitaPreventivo.errori?.messaggio ?? validitaPreventivo.validaCodice?.label ?? __t("nonvalido")}
                                </Alert>
                            )} */}
                            <Box display={"flex"} flexDirection={"row"}>
                                <Box p={1}>       
                                    <Box textAlign="right" pr={1}>
                                        <b>#{indicePreventivo+1}</b> 
                                        <br />
                                        <b>{prezzo}</b> 
                                        <br />
                                        <Typography variant="subtitle2">
                                            {qtatot} {tipoObj?.descrizione ?? ""}
                                        </Typography>
                                    </Box> 
                                </Box>     
                                <Box flexGrow={1} p={1}>   
                                    <Stack>
                                        <Typography variant="body1">
                                            {__t("ritiroprevisto")}: <b>{format(parse(preventivo.dataritiro, "yyyy-MM-dd", new Date()), "dd/MM/yyyy")}</b>
                                        </Typography>

                                        <Typography variant="body1">
                                            {__t("da")}: <b>{labelLocalita("partenza", preventivo)}</b>                                                
                                            <br />
                                            {__t("a")}: <b>{labelLocalita("arrivo", preventivo)}</b>
                                        </Typography>
                                    </Stack>        
                                </Box>
                            </Box>                                
                        </>
                    )} 
                />               
            </>
        ) : ""
        
    )
}

export default MenuCarrello;

export {Carrello, CODICICONVALIDACARRELLO, carrelloConErrori}